import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-demo-page',
    templateUrl: './demo-page.component.html',
    styleUrls: ['./demo-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DemoPageComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
